<div class="logs">
  <div class="form-inline" *ngIf="showFilters">
    <div class="form-group col-sm-auto col-xs-12">
      <label for="">Stock: </label>
      <select
        name="qty_type"
        id="qty_type"
        class="form-control"
        [(ngModel)]="filter.qty_type"
      >
        <option value="">All</option>
        <option value="qty_onhand" selected>On-Hand</option>
        <option value="qty_pending">Pending</option>
        <option value="qty_incoming">Incoming</option>
      </select>
    </div>

    <div class="form-group col-sm-auto col-xs-12">
      <label for="">Transaction: </label>
      <select
        name="transaction"
        id="transaction"
        class="form-control"
        [(ngModel)]="filter.transaction"
      >
        <option value="">All</option>
        <option
          *ngFor="
            let option of inventoryTransactionLookUp | sortBy: 'label' : 'asc'
          "
          [value]="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </div>

    <div class="form-group col-sm-auto col-xs-12">
      <label for="">Order #: </label>
      <input
        type="text"
        name="order_number"
        id="order_number"
        class="form-control"
        [(ngModel)]="filter.order_number"
      />
    </div>

    <div class="form-group col-sm-auto col-xs-12">
      <label for="">Order Date: </label>
      <input
        type="date"
        name="order_date"
        id="order_date"
        class="form-control"
        [(ngModel)]="filter.order_date"
      />
    </div>

    <div class="form-group col-sm-auto col-xs-12">
      <label for="">Channel: </label>
      <lum-channel-control
        [bindKey]="'id'"
        [inputClass]="'form-control'"
        [(ngModel)]="filter.channel"
        [isPosChannel]="null"
      ></lum-channel-control>
    </div>

    <div class="form-group col-sm-auto col-xs-12">
      <label for="">Warehouse Group: </label>
      <lum-location-warehouse-group-control
        [inputClass]="'form-control'"
        [(ngModel)]="filter.warehouseGroup"
      ></lum-location-warehouse-group-control>
    </div>

    <div class="form-group col-sm-auto col-xs-12">
      <label for="">Warehouse: </label>
      <lum-warehouse-search-dropdown
        [inputClass]="'form-control'"
        (selectItemEvent)="onSelectWarehouseFilter($event?.id)"
      ></lum-warehouse-search-dropdown>
    </div>

    <div class="form-group col-sm-auto col-xs-12">
      <button class="btn btn-info btn-sm mr-1" (click)="getRecords(false, 1)">
        GO
      </button>
      <button class="btn btn-outline-info btn-sm" (click)="resetFilters()">
        Reset Filters
      </button>
    </div>
  </div>

  <div class="result overflow-auto">
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="link" (click)="setOrder('qty_type')">
            Stock Type
            <ng-container
              *ngTemplateOutlet="
                sort;
                context: { order: filter.order, field: 'qty_type' }
              "
            >
            </ng-container>
          </th>
          <th class="link" class="link" (click)="setOrder('created_at')">
            DateTime
            <ng-container
              *ngTemplateOutlet="
                sort;
                context: { order: filter.order, field: 'created_at' }
              "
            >
            </ng-container>
          </th>
          <th>Warehouse</th>
          <!-- <th>
                        Location
                    </th> -->
          <th>Location (<b>Qty</b>)</th>
          <th *ngIf="lotTrackingEnabled">Lot (<b>Qty</b>)</th>
          <th class="link text-right" (click)="setOrder('quantity')">
            QTY
            <ng-container
              *ngTemplateOutlet="
                sort;
                context: { order: filter.order, field: 'quantity' }
              "
            >
            </ng-container>
          </th>
          <!-- <th class="link" (click)="setOrder('action')">
						Action
						<ng-container *ngTemplateOutlet="sort; context: { order: filter.order, field: 'action' }"> </ng-container>
					</th> -->
          <th class="text-right">Balance</th>

          <th class="link" (click)="setOrder('transaction')">
            Transaction
            <ng-container
              *ngTemplateOutlet="
                sort;
                context: { order: filter.order, field: 'transaction' }
              "
            >
            </ng-container>
          </th>
          <th>Posted By</th>
          <th>Channel</th>
          <th>Remarks</th>
          <!-- <th class="link" (click)="setOrder('order_number')">
						Order # [source]
						<ng-container *ngTemplateOutlet="sort; context: { order: filter.order, field: 'order_number' }"> </ng-container>
					</th>
					<th class="link" (click)="setOrder('order_date')">
						Order Date
						<ng-container *ngTemplateOutlet="sort; context: { order: filter.order, field: 'order_date' }"> </ng-container>
					</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading$ | async">
          <td colspan="11" class="text-center">
            <br />
            <h6 [translate]="'GENERAL.GETTING_RECORDS'">
              <i class="fas fa-spinner fa-spin"></i> Getting records...
            </h6>
            <br />
          </td>
        </tr>

        <tr *ngFor="let log of records.data; let i = index">
          <td>
            {{ log?.qtyType | qtytype }}
          </td>
          <td>
            {{ log?.createdAt | customDateTime: 'medium' : authData.timezone }}
          </td>
          <td>
            <span *ngIf="!log?.stock?.warehouse">N/A</span>
            <span *ngIf="log?.stock?.warehouse">{{
              log?.stock?.warehouse?.location_name
            }}</span>
          </td>
          <td>
            {{ log?.location?.locationName }}
            <span *ngIf="log.hasLocationAndBalance"
              >(<b>{{ log?.locationRunningBalance | decimalPlaces }}</b
              >)</span
            >
          </td>
          <td *ngIf="lotTrackingEnabled">
            {{ log?.rfqLot?.lotNumber }}
            <span *ngIf="log?.rfqLot"
              >(<b>{{ log?.lotRunningBalance | decimalPlaces }}</b
              >)</span
            >
          </td>
          <td class="text-right">
            {{ log?.quantity | decimalPlaces }}
          </td>
          <!-- <td>
						{{ log.action }}
					</td> -->
          <td class="text-right">
            {{ log?.runningQuantityBalance | decimalPlaces }}
          </td>
          <td>
            {{ log?.transaction }}
          </td>
          <td>
            <span *ngIf="log?.user">
              {{ log?.user?.firstname + ' ' + log?.user?.lastname }}
            </span>
            <span *ngIf="!log?.user"> SYSTEM </span>
          </td>
          <td>
            <span>
              {{ log.channelLabel }}
            </span>
          </td>
          <td>
            <cnc-sku-log-detail-remarks
              [log]="log"
              *ngIf="!(loading$ | async)"
            ></cnc-sku-log-detail-remarks>
          </td>
        </tr>
      </tbody>
    </table>

    <mat-paginator
      class="lum-paging lum-paging--dodge-back-to-top"
      [length]="records?.meta?.total"
      [pageSize]="records?.meta?.per_page"
      [pageIndex]="params.page - 1"
      [pageSizeOptions]="pageSizeOptions"
      (page)="getRecords($event)"
    >
    </mat-paginator>
  </div>
</div>

<ng-template #sort let-order="order" let-field="field">
  <div class="pull-right sort">
    <i class="fas fa-sort" *ngIf="!field || !order || order.indexOf(field) < 0"></i>
    <i class="fas fa-sort-up" *ngIf="order == field"></i>
    <i class="fas fa-sort-down" *ngIf="order == '-' + field"></i>
  </div>
</ng-template>
